import { render, staticRenderFns } from "./associationList.vue?vue&type=template&id=4e8144fc&"
import script from "./associationList.vue?vue&type=script&lang=js&"
export * from "./associationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports